module.exports = __webpack_public_path__ + "img/music_hover_icon.39cbc2f7.svg";